// Liste des nationalités (gentilés) en français
export const NATIONALITIES = [
  "Française",
  "Afghane", "Albanaise", "Algérienne", "Allemande", "Américaine", "Andorrane",
  "Angolaise", "Argentine", "Arménienne", "Australienne", "Autrichienne",
  "Azerbaïdjanaise", "Bahreïnienne", "Bangladaise", "Belge", "Béninoise",
  "Biélorusse", "Birmane", "Bolivienne", "Bosnienne", "Brésilienne",
  "Britannique", "Bulgare", "Burkinabée", "Burundaise", "Cambodgienne",
  "Camerounaise", "Canadienne", "Cap-verdienne", "Centrafricaine", "Chilienne",
  "Chinoise", "Chypriote", "Colombienne", "Comorienne", "Congolaise",
  "Coréenne", "Costaricaine", "Croate", "Cubaine", "Danoise", "Djiboutienne",
  "Dominicaine", "Égyptienne", "Émirienne", "Équatorienne", "Érythréenne",
  "Espagnole", "Estonienne", "Éthiopienne", "Fidjienne", "Finlandaise",
  "Gabonaise", "Gambienne", "Géorgienne", "Ghanéenne", "Grecque",
  "Guatémaltèque", "Guinéenne", "Haïtienne", "Hondurienne", "Hongroise",
  "Indienne", "Indonésienne", "Irakienne", "Iranienne", "Irlandaise",
  "Islandaise", "Israélienne", "Italienne", "Ivoirienne", "Jamaïcaine",
  "Japonaise", "Jordanienne", "Kazakhe", "Kényane", "Kirghize", "Kosovare",
  "Koweïtienne", "Laotienne", "Lettone", "Libanaise", "Libérienne", "Libyenne",
  "Liechtensteinoise", "Lituanienne", "Luxembourgeoise", "Macédonienne",
  "Malaisienne", "Malawite", "Maldivienne", "Malgache", "Malienne", "Maltaise",
  "Marocaine", "Mauricienne", "Mauritanienne", "Mexicaine", "Moldave",
  "Monégasque", "Mongole", "Monténégrine", "Mozambicaine", "Namibienne",
  "Népalaise", "Néerlandaise", "Néo-zélandaise", "Nicaraguayenne", "Nigériane",
  "Nigérienne", "Norvégienne", "Omanaise", "Ougandaise", "Ouzbèke",
  "Pakistanaise", "Palestinienne", "Panaméenne", "Paraguayenne", "Péruvienne",
  "Philippine", "Polonaise", "Portugaise", "Qatarienne", "Roumaine", "Russe",
  "Rwandaise", "Salvadorienne", "Saoudienne", "Sénégalaise", "Serbe",
  "Singapourienne", "Slovaque", "Slovène", "Somalienne", "Soudanaise",
  "Sri-lankaise", "Sud-africaine", "Suédoise", "Suisse", "Syrienne",
  "Tadjike", "Taïwanaise", "Tanzanienne", "Tchadienne", "Tchèque", "Thaïlandaise",
  "Togolaise", "Tunisienne", "Turkmène", "Turque", "Ukrainienne", "Uruguayenne",
  "Vénézuélienne", "Vietnamienne", "Yéménite", "Zambienne", "Zimbabwéenne",
  "Autre",
];
